import React from 'react';
import PropTypes from 'prop-types';
import { event } from '@minerva-analytics/pantheon';
import { useLocation } from "react-router-dom";
import { NavItem, Link } from './Nav.styles';

export const NavRouteItem = (props) => {
  const location = useLocation();
  const { route, text, toggleNav, children } = props;
  const active = location.pathname === route;

  return (
    <NavItem key={route} active={active}>
      <Link
        to={route}
        onClick={() => {
          event([`click`, `nav-item`, text]);
          toggleNav();
        }}
      >
        {children}
      </Link>
    </NavItem>
  );
};

NavRouteItem.propTypes = {
  route: PropTypes.string,
  text: PropTypes.string,
  toggleNav: PropTypes.func,
  children: PropTypes.node,
};
